import mobileIOS from './mobileIOS.png';
import mobileAndroid from './mobileAndroid.png';

export default { mobileIOS , mobileAndroid } 
